import ForgotpasswordForm from '../model/form.model';

class FormController {
  constructor(AccountApiService, FormService, StorageService, $window, $timeout, $translate, $location) {
    'ngInject';

    this.$window = $window;
    this.$timeout = $timeout;
    this.$translate = $translate;
    this.$location = $location;
    this.AccountApiService = AccountApiService;
    this.FormService = FormService;
    this.StorageService = StorageService;
  }

  $onInit() {
    this.form = new ForgotpasswordForm();
    this.checkOrigin();
    this.disableEnter();
  }

  checkOrigin() {
    this.$window.setTimeout(() => {
    let currentOrigin = this.$window.location.origin + '/';
      if (currentOrigin != this.$window.localStorage.getItem(origin)) {
        origin = this.$window.localStorage.getItem(origin);
      }
    }, 500);
  }

  disableEnter() {
    if (this.$window.event.keyCode == 13) {
      this.$window.event.preventDefault();
      return false;
    }
  }

  submitForm() {
    const locale = this.$location.search().lang || 'en';
    this.$translate.use(locale);

    this.FormService.isSubmitting.next(true);
    this.AccountApiService.sendResetCode(locale, this.form.toPayload())
    .then((resp) => {
      this.form.error = '';
      this.form.success = this.$translate.instant('Reset link was sent to your email.');
    })
    .catch((error) => {
      this.form.success = '';
      this.form.error = error.children.email.errors;
    })
    .finally(() => this.FormService.isSubmitting.next(false))
    ;
  }

  sendPostMessageToLoginForm() {
    parent.postMessage('amsRemember-pass', '*');
  }
}

export default FormController;



// WEBPACK FOOTER //
// ./client/app/pages/forgotpassword/component/form.controller.js